import React, { VFC } from 'react'

import LoadingJson from '@style-port/roov-ui-components-core/assets/lottie/loading.json'
import { Lottie } from '@style-port/roov-ui-components-react'

type Props = {
  className?: string
}

export const LoadingIcon: VFC<Props> = ({ className }) => {
  return (
    <div className={className}>
      <Lottie animationData={LoadingJson} />
    </div>
  )
}
